import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IWorkflow } from "@/interfaces/workflow.interface";
import workflowService from "@/services/workflow.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetWorkflowsReturn = RequestsBaseReturn<PaginatedResponse<IWorkflow> | null>;

export type UseGetWorkflowsProps = RequestPagination;

type GetAllSwrParams = [string, number, number];

const useGetWorkflowsBackoffice = ({
  pageNumber,
  pageSize,
}: UseGetWorkflowsProps): UseGetWorkflowsReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IWorkflow>, Error, GetAllSwrParams>(
    [SWR_KEYS.getWorkflows, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      workflowService.getAllBackoffice({ pageNumber: _pageNumber, pageSize: _pageSize }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetWorkflowsBackoffice;
